// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Style_wrapper__1Jcrw","input":"Style_input__HYMGp","text":"Style_text__201X7"};